const topbar = {
    docs: 'Dokumentacja',
    help: 'Pomoc',
};
export default Object.freeze(topbar);
